module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "nav"
    }
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('transition-group', {
    attrs: {
      "name": "nav__breadcrumb",
      "tag": "ul"
    }
  }, _vm._l((_vm.$route.matched), function(node, index) {
    return (node.meta.label) ? _c('li', {
      key: node.path,
      staticClass: "nav__breadcrumb"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.getRouterLink(index, node),
        "active-class": "nav__breadcrumb--active"
      }
    }, [_vm._v(_vm._s(_vm.getNodeLabel(node)))])], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('menu-group', {
    staticClass: "nav__meta",
    attrs: {
      "metaMenu": _vm.metaMenu
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0fecc32!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/Navigation.vue
// module id = 757
// module chunks = 1